import dibsCss from 'dibs-css';
import classnames from 'classnames';
import { type FC } from 'react';

type MoonProps = {
    className?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Moon: FC<MoonProps> = props => {
    return (
        <svg
            className={classnames(dibsCss.dibsIcon, props.className)}
            data-tn={'moon'}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            viewBox="0 0 20 20"
            fill="none"
        >
            <path d="M5.883 1.402a10.998 10.998 0 0012.208 14.247A9.56 9.56 0 115.883 1.402zM7.251 0a10.28 10.28 0 1012.435 14.511A10.28 10.28 0 017.251 0z" />
        </svg>
    );
};

export default Moon;
